var map = {
	"./music-instructions.json": 4309,
	"./music-library-intro2024.json": 4310,
	"./music-library-launch2024.json": 4311,
	"./music-progression.json": 4312,
	"./startSourcesAdvanced.json": 4313,
	"./startSourcesSimple.json": 4314,
	"./startSourcesSimple2.json": 4315,
	"./startSourcesTracks.json": 4316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4044;